$ = jQuery.noConflict()

$(document).ready(function () {
  $('.close').click(function () {
    const modal = $('.close').data('modal')
    $('#' + modal).removeClass('active')
  })

  $('.overlay').click(function () {
    const modal = $('.close').data('modal')
    $('#' + modal).removeClass('active')
  })
})

